export default "/d0578ba8920cbf5c8a83daf63eb0f338.jpg";